import React from 'react'
import { Divider, Modal } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import ButtonWhite from 'components/design/Form/ButtonWhite'
import classNames from 'classnames'
import constants from '../../../constants'
import customLanguageTexts from '../../../language'
import style from './style.module.scss'

const ModalSwitchingBack = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }
  const handleSwitchDashboardChange = (switchToOld = '') => {
    const dateNow = Date.now()
    dispatch({
      type: 'user/CUSTOMER_SWITCHED_DASHBOARD',
      payload: { switchToOld, dateNow, source: 'account settings toggle' },
      onComplete: handleSwitchBackToOldDashboard,
    })
  }

  const handleSwitchBackToOldDashboard = ({ error }) => {
    if (!error) {
      window.location.href = constants.betaDashboardHostingUrls.old
    }
  }
  const { visibleModalID, isMobileView } = settings
  const modalID = 'showFeedBackModal'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="custom__form__modal"
      open={visible}
      title={false}
      footer={false}
      onCancel={handleCancel}
      afterClose={handleCancel}
      maskClosable={false}
    >
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className={classNames(style.deletedAppContainer)}>
            <div className={style.headerMain}>
              <h1>{customLanguageTexts.SWITCHING_DASHBOARD_TITLE}</h1>
            </div>
            <Divider style={{ margin: '20px -24px', width: '110%' }} />
            <div className={style.bodyMain}>
              <p className={style.body}>{customLanguageTexts.SWITCHING_DASHBOARD_DES}</p>
            </div>
            <Divider style={{ margin: '20px -24px', width: '110%' }} />
            <div className={style.footerMain}>
              <a target="_blank" rel="noopener noreferrer" className={style.topLink}>
                <ButtonWhite
                  buttonText={isMobileView ? 'Switch back' : 'Switch to old dashboard'}
                  onClick={() => handleSwitchDashboardChange(true)}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalSwitchingBack
